const b2cEn = {
  en: {
    myPlan: {
      title: 'My Plan',
      product_category: 'Product Type',
      product_name: 'Product Name',
      policy_status: 'Status',
      policy_no: 'Appl / Policy No.',
    },
    myProfile: {
      title: 'My Profile',
      name: 'Name',
      phone_number: 'Phone Number',
      email: 'Email',
      res_address: 'Residential Address',
      corr_address: 'Corresponding Address',
      for_company_only: 'The below information is for Athena Best Financial Group record only',
      need_to_update_personal_info: 'If you would like to update the above information, please send an email to ',
      for_enquiry: 'For any inquiries, you can contact your consultant or ',
      enquiry_link: 'click here',
    },
    messageBox: {
      title: 'Message Box',
      subTitle: 'Title',
      type: 'Type',
      policy_no: 'Policy Number',
    },
    planDetail: {
      title: 'My Plan',
      overview: 'Plan Overview',
      details: 'Plan Details',
      form_download: 'Form Download',
      form_download_title: 'Document Title',
      form_download_link: 'Link',
      form_download_original: 'Original doc is required',
      form_download_copy: 'Copy can be accepted',
      auto_translate_remark_1: '',
      auto_translate_remark_2: '',
      assets_selection: 'Assets Selection',
      assets_performance_information: 'Assets Performance Information',
      hasl_announcement:
        "Heng An Standard Life has recently encountered some system issues and is unable to provide to us the latest price and valuation information. They are in the progress of fixing the problem and the service is expected to resume shortly. You may login to Heng An Standard Life's website to access to your policy's latest information",
    },
    statements: {
      monthly_statement: 'Monthly Statement',
      provider_statement: 'Statement From',
      policy_owner: 'Policy Owner',
      address: 'Address',
      contact_no: 'Contact No.',
      email: 'Email',
      print_out_date: 'Print Out Date',
      policy_no: 'Policy No.',
      plan_start_date: 'Plan Start Date',
      plan_term: 'Plan Term',
      payment_freq: 'Payment Frequency',
      pay_term: 'Pay Term',
      payment_method: 'Payment Method',
      policy_status: 'Policy Status',
      payment_status: 'Payment Status',
      portfolio_type: 'Portfolio Type',
      policy_plan_Name: 'Policy Plan Name',
      joint_policy_Owner: 'Joint Policy Owner',
      name_of_insured: 'Name of Insured',
      name_of_beneficiary: 'Name of Beneficiary',
      modal_premium: 'Modal Premium',
      modal_premium_for_insurance: 'Modal Premium',
      total_premium_paid: 'Total Premium Paid',
      estimated_premium_and_levy_amount: 'Estimated Premium & Levy Amount',
      next_contribute_due_date: 'Next Contribute Due Date',
      pending_transaction_amount: 'Pending Transaction Amount',
      withdrawal_amount: 'Withdrawal Amount',
      sum_insured: 'Sum Insured / Notional Amount',
      account_holder: 'Account Holder',
      account_no: 'Account No.',
      ac_opening_date: 'A/C Opening Date',
      account_type: 'Account Type',
      joint_account_holder: 'Joint Account Holder',
      report_currency: 'Report Currency',
      holding_type_I: 'INITIAL ACCOUNT',
      holding_type_A: 'ACCUMULATED ACCOUNT',
      holding_type_C: 'CURRENT HOLDINGS',
      fund_code: 'Fund Code',
      fund_name: 'Fund Name',
      unit_balance: 'Unit Balance', // FIXME: original need to add <br /> tag
      fund_currency: 'Fund Currency', // FIXME: original need to add <br /> tag
      unit_price: 'Unit Price', // FIXME: original need to add <br /> tag
      valuation_date: 'Valuation Date',
      in_fund_currency: 'In Fund Currency', // FIXME: original need to add <br /> tag
      in_plan_currency: 'In Plan Currency', // FIXME: original need to add <br /> tag
      sub_total: 'SUB-TOTAL',
      i_sub_total: 'SUB-TOTAL',
      a_sub_total: 'SUB-TOTAL',
      total_portfolio_value: 'TOTAL PORTFOLIO VALUE',
      total_portfolio_value_in_valuation_currency:
        'VALUATION CURRENCY EQUIVALENT',
      plan_type: 'Type',
      plan_name: 'Plan Name',
      total: 'Total',
      available_balance: 'AVAILABLE BALANCE',
      cash_balance: 'Cash Balance',
      currency_type: 'Currency Type',
      exch_rate: 'Exch. Rate',
      in_original_currency: 'In Original Currency', // FIXME: original need to add <br /> tag
      in_report_currency: 'In Report Currency', // FIXME: original need to add <br /> tag
      contribution_allocation: 'Contribution Allocation',
      portfolio_breakdown: 'Portfolio Breakdown',
      allocation_percentage: 'Allocation',
      portfolio_percentage: 'Portfolio',
      asset_class: 'Asset Class',
      disclaimer_1:
        'The above portfolio value may not be able to reflect the true value due to fund switching or dealing under process. Please check the value after the completion of such transactions.',
      disclaimer_2:
        'Please note that the prices of units and the income from them can go down as well as up. Past performance is not indicative for future performance. It is strongly recommended that you obtain and read the relevant prospectus/information memorandum prior to making an investment.',
      disclaimer_3:
        'Please verify and report to {{companyName}} for any inaccuracies in the information provided in this statement as soon as possible.',
      disclaimer_4:
        "** This valuation, as well as the exchange rates used, are for reference only. For actual number of units and valuation of client's holdings, please refer to the monthly / quarterly / annual valuation statements from Product Providers.",
      disclaimer_5:
        "{{companyName}} will only receive advisory fee by deducting units in client's account directly and will not accept any other means of payment.",
      metis_disclaimer_1:
        'Please refer to the fund factsheet for the detail holdings of each fund.',
      metis_disclaimer_2:
        'Prices of units can go down as well as up. Past performance is not indicative for future performance. It is strongly recommended that you obtain and read the relevant prospectus information memorandum prior to making an investment.',
      metis_disclaimer_3:
        'This valuation, as well as the exchange rates used, are for reference only. For actual number of units and valuation of client’s holdings, please refer to the valuation statements from Product Providers.',
      metis_disclaimer_4:
        'Please verify and report to {{companyName}} for any inaccuracies in the information provided in this statement as soon as possible.',
      abf_fund_descriptions:
        'ABF Multi-Asset Strategic Segregated Portfolio – Top 10 Holdings as of last month',
      abf_fund_allocation: 'Fund Holdings',
      etf_fund_descriptions:
        'ETF Strategic Fund - Portfolio Holding as of last month',
      etf_fund_allocation: 'Fund Holdings',
      life_policy_value: 'POLICY VALUE',
      pd_description: 'Description',
      life_amount: 'Amount',
      life_cash_value: 'Cash Value on Basic Sum Insured',
      life_dividend:           'Accumulated Dividend',
      life_future_deposit:     'Future Deposit',
      life_loan_balance:       'Loan Balance',
      life_total_policy_value: 'Total Policy Value',
      life_estimated_premium_and_levy_amount: 'Estimated Premium & Levy Amount',
      life_next_contribute_due_on: 'Next Contribute Due Date',
      life_next_due_premium: 'Next Premium Due',
      life_accumulated_guaranteed_coupon: 'Accumulated Guaranteed Coupon',
      life_terminal_dividend: 'Terminal Dividend',
      life_surrender_value: 'Surrender Value',
      life_vitality_discount: 'Vitality Discount',
      life_premium_refund: 'Premium Refund',
      life_next_levy: 'Next Levy'
    },
  },
};

export default b2cEn;
